export const Marquee = ({ items, reverse = false, testId }) => {
  const content = [...items, ...items];
  return (
    <div
      data-testid={testId}
      className="relative overflow-hidden border-y border-line/60 py-6 md:py-8 select-none"
    >
      <div className={`marquee-track ${reverse ? "reverse" : ""}`}>
        {content.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-4xl text-textMain/80 px-6 md:px-10">
              {item}
            </span>
            <span className="text-primary text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
